/**
 * Shared hover-state constants for all Charts-v2 chart types.
 *
 * Every chart with a hoverable datapoint imports from this file so the dim,
 * focus, overlay, and transition feel can be tuned from one place.
 */

/** Opacity for non-hovered datapoints when any datapoint is hovered. */
export const HOVER_DIMMED_OPACITY = 0.5

/** Opacity for the actively-hovered datapoint. */
export const HOVER_FOCUSED_OPACITY = 1

/**
 * Bubble + Scatter render translucent by default so overlapping points are
 * visible. Their hover dim is relative to that translucent base.
 */
export const HOVER_TRANSLUCENT_BASE_OPACITY = 0.45
export const HOVER_TRANSLUCENT_DIMMED_OPACITY = 0.15

/**
 * Fill for the row-overlay rect drawn behind the hovered row.
 * Slate-500 @ 15% alpha — lighter and bluer than Recharts' default grey cursor.
 *
 * Only applied to Horizontal Bar + Stacked Horizontal Bar.
 */
export const HOVER_ROW_OVERLAY_FILL = 'rgba(100, 116, 139, 0.15)'

/** Transition for opacity changes when entering/leaving the dimmed state. */
export const HOVER_TRANSITION_CSS = 'opacity 200ms ease'

/** Transition for the focused element (faster, so the hovered item snaps in). */
export const HOVER_FOCUS_TRANSITION_CSS = 'opacity 100ms ease'

/** Transition duration in ms — use when building compound transitions in CSS template literals. */
export const HOVER_TRANSITION_MS = 200

/**
 * Line charts dim non-hovered series much harder than other chart types: with
 * many interleaved series, half-opacity lines still read as a fully-present
 * crowd. The dim + desaturate pair below pushes the crowd into the background
 * so the focused series is the only vivid mark on the canvas — tune them
 * together.
 */
export const HOVER_LINE_DIMMED_OPACITY = 0.2
export const HOVER_LINE_DIMMED_FILTER = 'saturate(0.5)'

/** Stroke width of the focused line's curve (bases are 1.5–2). */
export const HOVER_LINE_FOCUSED_STROKE_WIDTH = 3.5

/** Line hover animates filter alongside opacity. */
export const HOVER_LINE_TRANSITION_CSS = `opacity ${HOVER_TRANSITION_MS}ms ease, filter ${HOVER_TRANSITION_MS}ms ease`
